import { defineStore } from 'pinia'
import { HomeService, ResponseError } from '@/services/app/home.service'
import type { AxiosResponse } from 'axios'

export const useHomeStore = defineStore('home', {
  state: () => ({
    responseData: '',
    responseErrorCode: 0,
    responseError: '',
  }),

  getters: {
    // Getter untuk responseErrorCode
    getResponseErrorCode: (state) => state.responseErrorCode,

    // Getter untuk responseError
    getResponseError: (state) => state.responseError,
  },

  actions: {
    // Memuat home
    async loadHome(params: string): Promise<AxiosResponse> {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await HomeService.home(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },
  },
})
